module.exports = __webpack_public_path__ + "img/christmas-offer-pre-bg.00e94c8a.png";